export default __webpack_public_path__ + "static/media/tuiguang.0f1a6383.png";